import { render } from "./DialogComponent.vue?vue&type=template&id=745f2317&scoped=true"
import script from "./DialogComponent.vue?vue&type=script&lang=js"
export * from "./DialogComponent.vue?vue&type=script&lang=js"

import "./DialogComponent.vue?vue&type=style&index=0&id=745f2317&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745f2317"]])

export default __exports__